export default function SpecialFeature() {
  return (
    <section className="w-full">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="relative overflow-hidden rounded-2xl">
          <img
            src="https://readdy.ai/api/search-image?query=people%20holding%20phones%20in%20a%20crowd%20watching%20breaking%20hot%20news%20together%20at%20dusk%2C%20city%20skyline%20silhouette%2C%20glowing%20warm%20orange%20and%20red%20screen%20light%2C%20documentary%20style%2C%20community%20and%20connection%20feeling%2C%20cinematic&width=1400&height=640&seq=specia-x1&orientation=landscape"
            alt="吃瓜群众围看手机实时热搜的晚间街头场景"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/60 to-foreground-950/20"></div>
          <div className="relative flex flex-col items-start gap-4 p-6 md:max-w-xl md:p-10">
            <span className="rounded-full bg-accent-400 px-3 py-1 text-xs font-bold text-foreground-950">本期深度专题</span>
            <h2 className="text-2xl font-bold leading-snug text-white md:text-3xl">
              热搜在刷屏，瓜该怎么吃才不迷路？
            </h2>
            <p className="text-sm leading-relaxed text-white/85 md:text-base">
              三条实用锦囊：先看权威信源再转评、警惕断章取义的截图、让子弹多飞一会儿。做清醒的吃瓜人，而不是被节奏带走的看客。
            </p>
            <div className="flex flex-wrap gap-3">
              <a
                href="#faq"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("faq")?.scrollIntoView({ behavior: "smooth" });
                }}
                className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600"
              >
                了解平台原则
              </a>
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("about")?.scrollIntoView({ behavior: "smooth" });
                }}
                className="whitespace-nowrap rounded-md border border-white/30 px-4 py-2 text-sm font-medium text-white transition hover:bg-white/10"
              >
                关于我们
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}